// Shown first when a signed-in user opens /reset-password or /accept-invite (FR-041): Continue ends
// the session on this device (pending join kept) and then shows the form; Cancel goes home.
import { useRef } from "react";
import { StyleSheet, View } from "react-native";

import { makeStyles } from "@/theme/makeStyles";
import { Button } from "@/ui/Button";
import { Text } from "@/ui/Text";

import { AUTH_COPY } from "../copy";
import { AuthCard } from "../ui/AuthCard";

export type SignedInInterstitialProps = {
  title: string;
  name: string;
  onContinue: () => void;
  onCancel: () => void;
};

const useStyles = makeStyles((t) =>
  StyleSheet.create({ actions: { gap: t.space.md } }),
);

export function SignedInInterstitial({
  title,
  name,
  onContinue,
  onCancel,
}: SignedInInterstitialProps) {
  const styles = useStyles();
  const continued = useRef(false);
  return (
    <AuthCard title={title} testID="signed-in-interstitial">
      <Text>{AUTH_COPY.interstitial.text(name)}</Text>
      <View style={styles.actions}>
        <Button
          onPress={() => {
            if (continued.current) return;
            continued.current = true;
            onContinue();
          }}
        >
          {AUTH_COPY.actions.continue}
        </Button>
        <Button variant="outline" onPress={onCancel}>
          {AUTH_COPY.actions.cancel}
        </Button>
      </View>
    </AuthCard>
  );
}
